<template>
    <div id=main-menu>

        <div class=menu-room>
            <img :src="require('@/assets/images/room/room.png')" usemap="#image-map">

            <map name="image-map">

                <router-link class=us-touching data-name="us touching" to="/us-touching"></router-link>

                <router-link class=us-and-machines data-name="us and machines" to="/us-and-machines" ></router-link>

                <router-link class=us-in-place data-name="us in place" to="/us-in-place" ></router-link>

                <router-link class=on-us data-name="on us" to="/on-us" ></router-link>

                <router-link class=inside-us data-name="inside us" to="/inside-us" ></router-link>

                <router-link class=us-with-other-people data-name="us with other people" to="/us-with-other-people" ></router-link>

                <router-link class=events data-name="events" to="/events" ></router-link>


            </map>

        </div>

        <ul class=mobile-menu>

            <li class=inside-us>
                <router-link to="/inside-us" alt="inside us"></router-link>
            </li>

            <li class=on-us>
                <router-link class=on-us to="/on-us" alt="On Us"></router-link>
            </li>

            <li class=us-touching>
                <router-link to="/us-touching"></router-link>
            </li>

            <li class=us-with-other-people>
                <router-link to="/us-with-other-people" alt="Us with other people"></router-link>
            </li>

            <li class=us-and-machines>
                <router-link to="/us-and-machines" alt="Us and Machines"></router-link>
            </li>

            <li class=us-in-place>
                <router-link to="/us-in-place" alt="us in place"></router-link>
            </li>

            <li class=events>
                <router-link class=events to="/events" alt="Events"></router-link>
            </li>


        </ul>
    </div>

</template>

<script>

    export default {
        name  : 'MainMenu',
        props : {},
        data() {
            return {
                hoverText     : ''   ,
                showHover     : false,
            }
        },
    }
</script>

<style lang="scss">
    .hover-text {
        position:absolute;
        opacity:0;

        &.visible {
            opacity: 1;
        }
    }
    .menu-room a {
        display:block;
        position:absolute;
        background-size:contain;
        background-repeat: no-repeat;
        opacity:0;
        transition:opacity .15s;

        &:before,
        &:after {
            position: absolute;
            opacity: 0;
            transition: .15s;
            pointer-events: none;
        }

        &:before {
            top: 0;
            width: 100px;
            height: 100px;
            background-size: contain;
            background-repeat: no-repeat;
        }

        &:after {
            content: attr(data-name);
            color: white;
            text-decoration: underline;
            font-size: 25px;
            font-weight: bold;
            white-space: nowrap;
            transform: scale(.9);
            text-shadow: 0 0 8px rgba(black, .5);
        }

        &:hover {
            opacity:1;

            &:before {
                opacity: 1;
                transform: scale(1.05);
            }

            &:after {
                opacity: 1;
                transform: scale(1);
            }
        }

        &[href$="us-with-other-people"] {
            background-image: url('~@/assets/images/room/us-with-other-people.png');
            top: 43.2%;
            left: 81.4%;
            width: 10%;
            height:12%;

            &:after {
                top: -19.8%;
                left: 56.4%;
            }
        }

        &[href$="inside-us"] {
            background-image: url('~@/assets/images/room/inside-us.png');
            top: 23.7%;
            left: 37.5%;
            width: 14%;
            height: 24%;

            &:after {
                top: -5%;
                left: 36.5%;
            }
        }

        &[href$="on-us"] {
            background-image: url('~@/assets/images/room/on-us.png');
            top: 66.6%;
            left: 74.2%;
            width: 11%;
            height: 13%;

            &:after {
                top: 67%;
                left: 77.2%;
            }
        }

        &[href$="us-in-place"] {
            background-image: url('~@/assets/images/room/us-in-place.png');
            top: 32.7%;
            left: 7.7%;
            width: 7.75%;
            height: 23%;
            transform: none;

            &:after {
                top: 47.2%;
                left:auto;
                right:110%;
            }
        }

        &[href$="us-and-machines"] {
            background-image: url('~@/assets/images/room/us-and-machines.png');
            top: 39.5%;
            left: 26.5%;
            width: 11.5%;
            height: 14%;

            &:after {
                top: 80.5%;
                left: 3.5%;
            }
        }

        &[href$="us-touching"] {
            background-image: url('~@/assets/images/room/us-touching.png');
            top: 60.4%;
            left: 14.9%;
            width: 16.4%;
            height: 20%;

            &:after {
                top: 49.7%;
                left: -42.1%;
            }
        }



        &[href$="events"] {
            background-image: url('~@/assets/images/room/events.png');
            top: 28.7%;
            left: 68.9%;
            width: 10%;
            height: 16%;
            transform: none;
            transition:opacity .2s, transform .2s;

            &:after {
                top: -13.3%;
                left: 18.9%;
            }

            &:hover:before {
                transform:scale(1.1);
                opacity:1;
            }
        }
    }

</style>